import { OrderStatus } from "@/types/order/order.common";
export const ORDER_CANCEL_INITIATOR_LABELS = {
    DISPATCHER: "Диспетчер",
    CLIENT: "Клиент",
};
export const DEFAULT_ORDER_CANCEL_INITIATOR = "DISPATCHER";
export const MIN_CANCEL_REASON_LENGTH = 5;
// Статусы, из которых до WP-DSP-FIX-03 был доступен переход в CANCELLED, кроме IN_PROGRESS (идёт работа
// техника). FAILED — чтобы неудачный заказ можно было закрыть отменой с причиной (пересдача 1, F1).
const CANCELLABLE_ORDER_STATUSES = new Set([
    OrderStatus.AWAITING_PAYMENT,
    OrderStatus.NEW,
    OrderStatus.CONFIRMED,
    OrderStatus.ASSIGNED,
    OrderStatus.EN_ROUTE,
    OrderStatus.ARRIVED,
    OrderStatus.FAILED,
]);
/** Статусы отмены — в «Изменить статус» их нет, отмена только кнопкой «Отменить». */
export const ORDER_CANCEL_STATUSES = new Set([
    OrderStatus.CANCELLED,
    OrderStatus.DISPATCHER_CANCELLED,
]);
export const canCancelOrder = (status) => CANCELLABLE_ORDER_STATUSES.has(status);
export const getOrderCancelStatus = (initiator) => initiator === "CLIENT" ? OrderStatus.CANCELLED : OrderStatus.DISPATCHER_CANCELLED;
export const normalizeCancelReason = (reason) => (reason ?? "").trim();
export const isCancelReasonValid = (reason) => normalizeCancelReason(reason).length >= MIN_CANCEL_REASON_LENGTH;
/** Статус и причина для `changeOrderStatus`; невалидная причина — ошибка (модалка её не пропускает). */
export const buildOrderCancelRequest = (initiator, reason) => {
    if (!isCancelReasonValid(reason)) {
        throw new Error(`Причина отмены — не короче ${MIN_CANCEL_REASON_LENGTH} символов`);
    }
    return { status: getOrderCancelStatus(initiator), reason: normalizeCancelReason(reason) };
};
/** Отмена через существующий `orderService.changeOrderStatus` — история статусов с причиной пишется им же. */
export const submitOrderCancel = async (changeOrderStatus, orderId, initiator, reason) => {
    const request = buildOrderCancelRequest(initiator, reason);
    await changeOrderStatus(orderId, request.status, request.reason);
    return request;
};
